export const ROLE_TYPE = {
  renter: 'renter',
  owner: 'owner'
}

export const ROLE_TYPE_NAME = {
  renter: 'Renter',
  owner: 'Owner'
}
